import React, { Component } from "react";
import exportFromJSON from "export-from-json";

class ExportCSV extends Component {
  state = {
    name: "",
    id: "",
    placeholder: "",
    attributes: "",
    value: "",
    defaultValue: "",
    loaded: false,
    editable: true,
    component: null,
    attributes: "",
    events: "",
    caption: "",
    data: [],
  };

  constructor(props) {
    super(props);

    let events = {};

    this.options = this.options.bind(this);
    if (this.props.property.events) {
      Object.keys(this.props.property.events).map((itm, idx) => {
        this[itm] = this.props.property.events[itm];
        this[itm] = this[itm].bind(this);
        events[itm] = this[itm];
      });
    }
    this.state = {
      events: events,
    };
  }

  export(type, fileName = "data") {
    let exportType = exportFromJSON.types.csv;

    switch (type) {
      case "xls":
        exportType = exportFromJSON.types.xls;
        break;

      case "txt":
        exportType = exportFromJSON.types.txt;
        break;
    }

    exportFromJSON({
      data: this.state.data,
      fileName: fileName,
      exportType: exportType,
    });
  }

  options() {
    let output = [];
    if (this.props.property.configuration) {
      if (this.props.property.configuration.options) {
        Object.keys(this.props.property.configuration.options).map(
          (itm, idx) => {
            let onClickFun = function () {};

            try {
              onClickFun =
                this.props.property.configuration.options[itm].events.onClick;
            } catch (e) {}

            if (this.props.property.configuration.options[itm].checkbox) {
              output.push(
                <div className="input-group pl-3 dropdown-item">
                  <input
                    type="checkbox"
                    style={{ marginTop: "5px" }}
                    onClick={onClickFun.bind(this)}
                  />
                  <label className="ml-2">
                    {this.props.property.configuration.options[itm].label}
                  </label>
                </div>
              );
            } else {
              output.push(
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={onClickFun.bind(this)}
                >
                  {this.props.property.configuration.options[itm].label}
                </button>
              );
            }
          }
        );
      }
    }
    return output;
  }

  componentDidMount() {
    this.setState({
      defaultValue: this.props.value,
      attributes: this.props.property.attributes,
      caption: this.props.property.caption,
    });
    if (this.didMount) {
      this.didMount();
    }
  }

  render() {
    return (
      <div className="dropdown">
        <button
          type="button"
          {...this.state.attributes}
          {...this.state.events}
          data-toggle="dropdown"
        >
          {this.state.caption}
        </button>
        <div class="dropdown-menu">{this.options()}</div>
      </div>
    );
  }
}

export default ExportCSV;
